import styled  from '@emotion/styled'


export const BayName = styled.div`
  ${({theme}) => theme.font.heading3}

  &.off {
    color: #5A6A81;
  }
  
  &.lg {
    font-size: 22px;
  }

  &.md {
    font-size: 18px;
  }

  &.sm {
    font-size: 14px;
  }
`
